/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_Reason_No_Write_AccessInputs */



/**
* | output |
* | --- |
* | "it is read-only for you, and the agent writes to it. An admin of \"{name}\" can give you write access." |
*
* @param {Agent_Access_Reason_No_Write_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_reason_no_write_access = /** @type {((inputs: Agent_Access_Reason_No_Write_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Reason_No_Write_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Für Sie nur lesbar, der Agent schreibt aber hinein. Ein Admin von „${i?.name}“ kann Ihnen Schreibzugriff geben.`)
	return /** @type {LocalizedString} */ (`it is read-only for you, and the agent writes to it. An admin of "${i?.name}" can give you write access.`)
});